import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import {
  FaLaptopCode,
  FaPython,
  FaJava,
  FaMobile,
  FaCloud,
  FaMicrochip,
  FaRobot,
  FaIndustry,
  FaArrowRight,
  FaQuestionCircle,
  FaChalkboardTeacher,
  FaHandshake,
  FaCertificate,
  FaBriefcase,
  FaCheckCircle,
  FaStar,
  FaCalendarAlt,
  FaClock,
  FaUsers,
  FaTrophy,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import PublicNavbar from "../../components/public/Navbar";
import Footer from "../../components/public/Footer";
import "../../styles/vocational-page.css";

const VocationalTraining = () => {
  const navigate = useNavigate();
  const [openFaq, setOpenFaq] = useState(null);
  const [activeFilter, setActiveFilter] = useState("all");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  const courses = [
    {
      icon: <FaLaptopCode />,
      title: "Web Development",
      color: "#3498DB",
      description:
        "HTML, CSS, JavaScript, React.js, Node.js, PHP, MySQL, MongoDB",
      path: "/courses",
    },
    {
      icon: <FaPython />,
      title: "Python Programming",
      color: "#2ECC71",
      description: "Core concepts, OOP, NumPy, Pandas, Matplotlib, Django",
      path: "/courses",
    },
    {
      icon: <FaJava />,
      title: "Java Development",
      color: "#E74C3C",
      description: "OOP, Collections, Multithreading, JDBC with MySQL",
      path: "/courses",
    },
    {
      icon: <FaMobile />,
      title: "Android App",
      color: "#9B59B6",
      description: "Flutter, Dart, Cross-platform apps, UI/UX Design",
      path: "/courses",
    },
    {
      icon: <FaCloud />,
      title: "AWS Cloud",
      color: "#F39C12",
      description: "EC2, S3, RDS, Lambda, IAM, VPC, CloudFormation",
      path: "/courses",
    },
    {
      icon: <FaMicrochip />,
      title: "Arduino",
      color: "#1ABC9C",
      description:
        "Circuit design, Motor control, Sensor integration, IoT basics",
      path: "/courses",
    },
    {
      icon: <FaRobot />,
      title: "Robotics & IoT",
      color: "#E67E22",
      description: "Arduino, Raspberry Pi, Sensors, Actuators, Automation",
      path: "/courses",
    },
    {
      icon: <FaIndustry />,
      title: "PLC & SCADA",
      color: "#34495E",
      description: "Industrial automation, Siemens, Allen-Bradley, HMI",
      path: "/courses",
    },
  ];

  const stats = [
    {
      icon: <FaUsers />,
      number: "8760+",
      label: "Students Trained",
      color: "#3498DB",
    },
    {
      icon: <FaTrophy />,
      number: "95%",
      label: "Placement Rate",
      color: "#2ECC71",
    },
    {
      icon: <FaCalendarAlt />,
      number: "21+",
      label: "Years Experience",
      color: "#F39C12",
    },
    {
      icon: <FaStar />,
      number: "4.9",
      label: "Student Rating",
      color: "#E74C3C",
    },
  ];

  const projects = [
    {
      id: 1,
      title: "E-Commerce Platform",
      category: "web",
      icon: "🛒",
      student: "Rahul S.",
      description: "Full-stack e-commerce with payment gateway",
    },
    {
      id: 2,
      title: "Health Care App",
      category: "mobile",
      icon: "🏥",
      student: "Priya M.",
      description: "Doctor appointment booking system",
    },
    {
      id: 3,
      title: "Line Following Robot",
      category: "robotics",
      icon: "🤖",
      student: "Amit K.",
      description: "Autonomous robot using IR sensors",
    },
    {
      id: 4,
      title: "Smart Home System",
      category: "robotics",
      icon: "🏠",
      student: "Neha S.",
      description: "IoT based home automation",
    },
    {
      id: 5,
      title: "Portfolio Website",
      category: "web",
      icon: "💼",
      student: "Vikram P.",
      description: "Responsive personal portfolio",
    },
    {
      id: 6,
      title: "Weather App",
      category: "mobile",
      icon: "🌤️",
      student: "Anjali R.",
      description: "Real-time weather application",
    },
  ];

  const filteredProjects =
    activeFilter === "all"
      ? projects
      : projects.filter((p) => p.category === activeFilter);

  const faqs = [
    {
      q: "🎓 What is vocational training?",
      a: "Vocational training focuses on practical skills, hands-on experience, and problem-solving abilities directly applicable in the workplace.",
    },
    {
      q: "👨‍🎓 Who is eligible for vocational training?",
      a: "Students pursuing B.Tech, M.Tech, MCA, BCA, B.Sc, M.Sc in CS/IT, and working professionals looking to upskill are eligible.",
    },
    {
      q: "💡 How is vocational training different from regular courses?",
      a: "It emphasizes practical, project-based learning over theoretical knowledge, preparing you directly for industry roles.",
    },
    {
      q: "⏰ What is the duration of the training?",
      a: "Training durations vary by program, ranging from 2 months to 6 months with flexible scheduling.",
    },
    {
      q: "🏆 Will I get a certificate?",
      a: "Yes, you will receive a recognized vocational training certificate from Sensible Academy.",
    },
    {
      q: "💼 Is there any placement assistance?",
      a: "Yes, we provide 100% placement assistance including resume building, mock interviews, and direct referrals to partner companies.",
    },
  ];

  const benefits = [
    {
      icon: <FaChalkboardTeacher />,
      title: "Practical Skills",
      desc: "Hands-on training with real-world projects from industry experts",
    },
    {
      icon: <FaHandshake />,
      title: "Industry Ready",
      desc: "Learn tools and technologies currently used in the industry",
    },
    {
      icon: <FaCertificate />,
      title: "Certification",
      desc: "Recognized certificate with placement support and verification",
    },
    {
      icon: <FaBriefcase />,
      title: "Career Growth",
      desc: "Build skills for long-term career success and growth",
    },
  ];

  return (
    <div className="vocational-page-wrapper">
      <PublicNavbar />
      <div className="vocational-page-nav-spacer"></div>

      {/* Hero Section */}
      <section className="vocational-page-hero">
        <div className="vocational-page-hero-bubbles">
          <div className="vocational-page-bubble"></div>
          <div className="vocational-page-bubble"></div>
          <div className="vocational-page-bubble"></div>
          <div className="vocational-page-bubble"></div>
          <div className="vocational-page-bubble"></div>
        </div>
        <Container>
          <div className="vocational-page-hero-content">
            <div className="vocational-page-hero-badge">
              <span>🚀</span>
              <span>Enroll Now for 2026 Batch</span>
              <span>✨</span>
            </div>
            <h1 className="vocational-page-hero-title">
              VOCATIONAL{" "}
              <span className="vocational-page-highlight">TRAINING</span>{" "}
              PROGRAM
            </h1>
            <h2 className="vocational-page-hero-subtitle">
              Bridging the Gap Between Academic Learning and Industry
            </h2>
            <p className="vocational-page-hero-description">
              Vocational training plays a crucial role in the professional
              development of computer engineers by bridging the gap between
              academic learning and real-world industry requirements. Get
              hands-on experience with live projects.
            </p>
            <div className="vocational-page-hero-buttons">
              <button
                className="vocational-page-hero-btn-primary"
                onClick={() => navigate("/contact")}
              >
                Enroll Now <FaArrowRight className="ms-2" />
              </button>
              <button
                className="vocational-page-hero-btn-secondary"
                onClick={() => navigate("/contact")}
              >
                Download Brochure
              </button>
            </div>
          </div>
        </Container>
        <div className="vocational-page-hero-wave">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1440 120"
            preserveAspectRatio="none"
          >
            <path
              fill="#ffffff"
              fillOpacity="1"
              d="M0,64L48,80C96,96,192,128,288,128C384,128,480,96,576,85.3C672,75,768,85,864,96C960,107,1056,117,1152,112C1248,107,1344,85,1392,74.7L1440,64L1440,120L1392,120C1344,120,1248,120,1152,120C1056,120,960,120,864,120C768,120,672,120,576,120C480,120,384,120,288,120C192,120,96,120,48,120L0,120Z"
            ></path>
          </svg>
        </div>
      </section>

      {/* Stats Section */}
      <Container className="vocational-page-stats">
        <Row className="g-4">
          {stats.map((stat, index) => (
            <Col md={3} sm={6} key={index}>
              <div className="vocational-page-stat-card">
                <div
                  className="vocational-page-stat-icon"
                  style={{ background: stat.color }}
                >
                  {stat.icon}
                </div>
                <h3>{stat.number}</h3>
                <p>{stat.label}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>

      {/* Benefits Section */}
      <Container className="vocational-page-container">
        <div className="vocational-page-section-header text-center">
          <h2>
            Why{" "}
            <span className="vocational-page-highlight">
              Vocational Training
            </span>
            ?
          </h2>
          <p>Build practical skills that employers are looking for</p>
        </div>
        <Row className="g-4">
          {benefits.map((benefit, index) => (
            <Col md={3} sm={6} key={index}>
              <div className="vocational-page-benefit-card">
                <div className="vocational-page-benefit-icon">
                  {benefit.icon}
                </div>
                <h4>{benefit.title}</h4>
                <p>{benefit.desc}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>

      {/* Programs Section */}
      <section className="vocational-page-courses-section">
        <Container>
          <div className="vocational-page-section-header text-center">
            <h2>
              Training{" "}
              <span className="vocational-page-highlight">Programs</span>
            </h2>
            <p>Choose your specialization from our industry-aligned programs</p>
          </div>
          <Row className="g-4">
            {courses.map((course, index) => (
              <Col md={6} lg={3} key={index}>
                <div className="vocational-page-course-card">
                  <div
                    className="vocational-page-course-icon"
                    style={{ backgroundColor: course.color }}
                  >
                    {course.icon}
                  </div>
                  <h3>{course.title}</h3>
                  <p>{course.description}</p>
                  <button
                    className="vocational-page-course-btn"
                    onClick={() => navigate(course.path)}
                  >
                    Learn More →
                  </button>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Portfolio Section */}
      <Container className="vocational-page-container">
        <div className="vocational-page-section-header text-center">
          <h2>
            Student <span className="vocational-page-highlight">Portfolio</span>
          </h2>
          <p>Celebrating the incredible work of our students</p>
        </div>

        <div className="vocational-page-portfolio-filters">
          <button
            className={`vocational-page-filter-btn ${activeFilter === "all" ? "active" : ""}`}
            onClick={() => setActiveFilter("all")}
          >
            ALL
          </button>
          <button
            className={`vocational-page-filter-btn ${activeFilter === "web" ? "active" : ""}`}
            onClick={() => setActiveFilter("web")}
          >
            🌐 WEB APPS
          </button>
          <button
            className={`vocational-page-filter-btn ${activeFilter === "robotics" ? "active" : ""}`}
            onClick={() => setActiveFilter("robotics")}
          >
            🤖 ROBOTICS
          </button>
          <button
            className={`vocational-page-filter-btn ${activeFilter === "mobile" ? "active" : ""}`}
            onClick={() => setActiveFilter("mobile")}
          >
            📱 MOBILE APPS
          </button>
        </div>

        <Row className="g-4">
          {filteredProjects.map((project) => (
            <Col md={6} lg={4} key={project.id}>
              <div className="vocational-page-portfolio-card">
                <div className="vocational-page-portfolio-icon">
                  {project.icon}
                </div>
                <div className="vocational-page-portfolio-info">
                  <h4>{project.title}</h4>
                  <p>{project.description}</p>
                  <div className="vocational-page-portfolio-student">
                    <FaCheckCircle className="me-1" /> {project.student}
                  </div>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>

      {/* FAQ Section */}
      <section className="vocational-page-faq-section">
        <Container>
          <div className="vocational-page-section-header text-center">
            <h2>
              Frequently Asked{" "}
              <span className="vocational-page-highlight">Questions</span>
            </h2>
            <p>Get answers to common vocational training questions</p>
          </div>
          <Row className="justify-content-center">
            <Col lg={10}>
              <div className="vocational-page-faq-container">
                {faqs.map((faq, index) => (
                  <div
                    key={index}
                    className={`vocational-page-faq-item ${openFaq === index ? "active" : ""}`}
                  >
                    <div
                      className="vocational-page-faq-question"
                      onClick={() => toggleFaq(index)}
                    >
                      <h4>{faq.q}</h4>
                      <span className="vocational-page-faq-icon">
                        {openFaq === index ? "−" : "+"}
                      </span>
                    </div>
                    <div className="vocational-page-faq-answer">
                      <p>{faq.a}</p>
                    </div>
                  </div>
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* CTA Section */}
      <section className="vocational-page-cta-section">
        <Container>
          <Row className="align-items-center">
            <Col lg={8}>
              <div className="vocational-page-cta-content">
                <h2>Ready to Build Your Career?</h2>
                <p>
                  Join our vocational training program and become industry-ready
                </p>
                <div className="vocational-page-cta-buttons">
                  <button
                    className="vocational-page-cta-primary"
                    onClick={() => navigate("/contact")}
                  >
                    Register Now <FaArrowRight className="ms-2" />
                  </button>
                  <button
                    className="vocational-page-cta-secondary"
                    onClick={() => navigate("/contact")}
                  >
                    Download Brochure
                  </button>
                </div>
              </div>
            </Col>
            <Col lg={4} className="text-center">
              <div className="vocational-page-cta-emoji">
                <span>📚</span>
                <span>💻</span>
                <span>🎯</span>
                <span>🚀</span>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <Footer />
    </div>
  );
};

export default VocationalTraining;
